import apiClient from './apiClient';

export const getNonRefundSections = async () => {
  const { data } = await apiClient.get('/api/non-refund-policy');
  return Array.isArray(data) ? data : [];
};

export const saveNonRefundSections = async (sections) => {
  const { data } = await apiClient.put('/api/non-refund-policy', sections || []);
  return Array.isArray(data) ? data : [];
};

